import Box from "@mui/material/Box";
import {
  Avatar,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Program, ProgramDate } from "../../models/Program";
import { getNext7DaysWithDayNames } from "../../utils/API";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { renderTimeViewClock, TimePicker } from "@mui/x-date-pickers";
import { useLocation } from "react-router";
import { useFormik } from "formik";
import { ProgramValidationsForm } from "./Validation";
import { LoadingButton } from "@mui/lab";
import { Notify } from "../../layouts/notify";
import {
  useAddProgramMutation,
  useDeleteProgramMutation,
  useLazyGetProgramsQuery,
} from "../../services/channel.query";
import { DefaultPage } from "../../layouts/default-page";
import { Add, Delete } from "@mui/icons-material";
import { format } from "date-fns";
import { DataTable } from "../../layouts/data-table";
import DeleteConfirmationDialog from "../../layouts/delete-confirm";
import { useGetCategoriesQuery } from "../../services/movies.query";
import { useAddTVProgramScheduleMutation, useGetTVProgramQuery, useGetTVProgramsQuery, useLazyGetTVProgramsByChannelQuery } from "../../services/tvprograms.query";
import type { TVProgramSchedule } from "../../models/TVProgramSchedule";


export default function TVProgramSchedule() {
  let { state } = useLocation();
  console.log("state", state);
  const [programs, setProgram] = React.useState<Program[]>([]);
  const [selectedItem, setSelectedItem] = React.useState<any>("");
  const [selectedDay, setSelectedDay] = React.useState<any>("");
  const [selectedDBDayColumnName, setSelectedDBDayColumnName] = React.useState<any>(""); //new
  const [dates, setDates] = useState<ProgramDate[]>([]);
  const [dbDayColumnName, setDbDayColumnName] = React.useState<any>("");
  const [active, setActive] = React.useState<boolean>(false);
  const [deleteTVProgram, { isLoading: deleting }] = useDeleteProgramMutation();
  const [addProgram, { isLoading: adding }] = useAddTVProgramScheduleMutation();
  const [openDeleteModal, setOpenDeleteModal] = React.useState<boolean>(false);
  // console.log("programs,programs", programs);
  // console.log("dates", dates[0]?.dayName);
  const [itemTobeDeleted, setItemTobeDelete] = React.useState<any>(null);

  const handleOPenDelete = (row: any) => {
    setOpenDeleteModal(true);
    setItemTobeDelete(row);
  };

  const deleteItem = async () => {
    await deleteTVProgram(itemTobeDeleted.id);
    setOpenDeleteModal(false);
  };
  const [
    triggerProgram,
    {
      data: fetchedPrograms,
      isLoading: programsLoading,
      isFetching: programsFetching,
      isSuccess: programsSUccess,
      isError: programsError,
    },
  ] = useLazyGetTVProgramsByChannelQuery();

  useEffect(() => {
    if (state.channel?.id && dates) {
      triggerProgram({
        channelId: state?.channel?.id,
        dayActive: selectedDay ?? dates[0]?.dayName,
      });
    }
  }, [dates, selectedDay, state.channel?.id]);
  const [open, setOpen] = React.useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  const getSelectedDbColumnName = (selectedDay: string): string => {

    return 'Test';
  };

  useEffect(() => {


    const fetchProgramDate = () => {
      const _programsDates: ProgramDate[] = getNext7DaysWithDayNames();
      setDates(_programsDates);
      setSelectedItem(_programsDates[0]?.date); // Set default selected date on initial load 
      setSelectedDay(_programsDates[0]?.dayName);
    };
    fetchProgramDate();
  }, []);

  const { data: tvPrograms } = useGetTVProgramsQuery("");


  //Submit for Adding program on selected day
  const formik = useFormik({
    initialValues: {
      tv_program_id: null,
    },
    validationSchema: ProgramValidationsForm,
    onSubmit: async (values, { resetForm }) => {
      console.log('awdawd');
      // let data: TVProgramSchedule = {
      //   tv_program_id: values.tv_program_id as unknown as number,      
      // };
    
      await addProgram({tv_program_id:15});
      Notify("info", "TV Program Added Successfully");
      resetForm();
      setOpen(false);
    },
  });
  const columns = [
    {
      accessorKey: "id",
      header: "ID",
    },
    {
      accessorKey: "tv_program.image",
      header: "",
      Cell: ({ row }: any) => {
        return (
          <>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <img
                src={row.original.tv_program.image}
                style={{ width: 35, height: 35, cursor: "pointer" }}
                onClick={() => window.open(row.original.tv_program.image, "_blank")}
              />
            </Box>{" "}
          </>
        );
      },
    },
    {
      accessorKey: "tv_program.title",
      header: "Program Name",
    },
    {
      accessorKey: "monday_time",
      header: "Time",
      Cell: ({ row }: any) => {
        // Assuming start_time and end_time are in 'HH:mm:ss' format
        const time = new Date(`1970-01-01T${row.original.monday_time}`);

        const formattedStartTime = time.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });



        return `${formattedStartTime}`;
      },
    },
    {
      accessorKey: "is_active",
      header: "Active",
    },

  ];
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          padding: 1,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            width: "100%",
            height: "10%",
            padding: "15px 26px 16px 25px",
            gap: 4,
            borderRadius: "15px",
            opacity: "0px",
            background: "linear-gradient(180deg, #2891FF 0%, #63AFFF 100%)",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {dates.map((date, index) => (
            <Box
              key={index}
              sx={{
                padding: "10px 15px",
                cursor: "pointer",
                backgroundColor:
                  selectedItem === date.date ? "#0054D3" : "white",
                "&:hover": { backgroundColor: "#2891FF" },
                borderRadius: "20px",
              }}
              onClick={() => { setSelectedItem(date.date); setSelectedDay(date.dayName); }}
            >
              <Typography
                sx={{
                  color: selectedItem === date.date ? "white" : "black",
                  fontSize: 25,
                  fontWeight: 600,
                }}
              >
                {date.date?.split("-")[2]}
              </Typography>
              <Typography
                sx={{
                  color: selectedItem === date.date ? "#DADADA" : "#535353",
                  fontSize: 14,
                }}
              >
                {date.dayName}
              </Typography>
            </Box>
          ))}
        </Paper>

        <DefaultPage

          title={"Channel: " + state?.channel?.title}
          primaryButtonProps={{
            startIcon: <Add />,
            disabled: !selectedItem,
            children: "Add New Program for this Day",
            onClick: () => {
              setOpen(true);
            },
          }}
        >
          <DataTable
            count={fetchedPrograms?.length}
            columns={columns}
            globalFilter={""}
            list={fetchedPrograms as any}
            getRowId={(row: { id: any }) => row.id}
            isLoading={programsLoading}
            isSuccess={programsSUccess}
            isFetching={programsFetching}
            enableBottomToolbar={true}
            isError={programsError}
            renderRowActions={({ row }: any) => (
              <Box sx={{ display: "flex" }}>
                <Button
                  color="error"
                  onClick={() => handleOPenDelete(row?.original)}
                >
                  <Delete />
                </Button>
              </Box>
            )}
          />
        </DefaultPage>

        <div>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "white",
                height: "320px",
                width: "500px",
                borderRadius: "15px",
                padding: "15px",
              }}
            >
              <IconButton
                aria-label="close"
                onClick={() => handleClose()}
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <img alt={"close icon"} src={"/x.png"} />
              </IconButton>



              <form noValidate onSubmit={formik.handleSubmit}>
                <DialogContent>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "15px",
                    }}
                  >
                    <FormControl>
                      <label
                        style={{
                          color: "#AFAFAF",
                          marginBottom: "7px",
                        }}
                      >
                        TV Program
                      </label>
                      <TextField
                        sx={{
                          width: "100%",
                          height: "auto",
                        }}
                        InputLabelProps={{
                          style: {
                            // fontSize: '15px',
                          },
                        }}
                        id="id_tv_program"
                        select
                        name="tv_program_id"
                        variant="outlined"
                        SelectProps={{
                          IconComponent: ExpandMoreIcon,
                        }}
                        value={formik.values.tv_program_id}
                        onChange={formik.handleChange}
                        error={
                          formik.touched.tv_program_id &&
                          Boolean(formik.errors.tv_program_id)
                        }
                        helperText={
                          formik.touched.tv_program_id &&
                          formik.errors.tv_program_id
                        }
                        onBlur={formik.handleBlur}
                      >
                        {tvPrograms?.map((tvPrograms: any) => (
                          <MenuItem key={tvPrograms.id} value={tvPrograms.id}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <Avatar
                                src={tvPrograms.image}
                                alt={tvPrograms.title}
                                sx={{ width: 30, height: 30, marginRight: 2, borderRadius: '2px' }}
                              />
                              <Typography>{tvPrograms.title}</Typography>
                            </Box>
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                    {/* <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignContent: "center",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    > */}
                      {/* <FormControl>
                        <label
                          style={{
                            color: "#AFAFAF",
                          }}
                        >
                          Start Time
                        </label>

                        <DemoContainer components={["TimePicker"]}>
                          <TimePicker
                            sx={{
                              width: "60%",
                              margin: "0px",
                            }}
                            label="Time Clock"
                            onChange={(newValue) =>
                              formik.setFieldValue(
                                "start_time",
                                newValue?.format("HH:mm:ss") as string
                              )
                            }
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                          />
                        </DemoContainer>
                        {formik.touched.start_time &&
                          Boolean(formik.errors.start_time) ? (
                          <span style={{ color: "red" }}>
                            {formik.errors.start_time}
                          </span>
                        ) : null}
                      </FormControl> */}

                    {/* </div> */}
                  </div>
                </DialogContent>
                <DialogActions>
                  <Grid container spacing={2}>
                    <Grid item xs={1} sm={1} md={1} />

                    <Grid item xs={10} sm={10} md={10}>
                      <LoadingButton
                        color="primary"
                        type={"submit"}
                        loading={adding}
                        sx={{
                          textTransform: "none",
                          color: "white",
                          width: "100%",
                          borderRadius: "20px",
                          "&:hover": {
                            backgroundColor: "#5489de",
                            color: "white",
                          },
                          margin: 1,
                          backgroundColor: "#0054D3",
                        }}
                      >
                        Add New Program
                      </LoadingButton>
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} />
                  </Grid>
                </DialogActions>
              </form>
            </Paper>
          </Dialog>
        </div>

        <DeleteConfirmationDialog
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={deleteItem}
          loading={deleting}
          item={itemTobeDeleted?.id}
          itemName={itemTobeDeleted?.program_name}
        />
      </Box>
    </>
  );
}
